// extracted by mini-css-extract-plugin
export default {"addButton":"styles_addButton__Vsbn2","add":"styles_add__qbDQ+"};